import React from 'react';
import * as Toast from '@radix-ui/react-toast';
import { ErrorSvg } from '../../styles/icons/ErrorSvg';
import { SuccessSvg } from '../../styles/icons/SuccessSvg';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';

export type Notification = {
  title: string;
  type: 'error' | 'success';
}

export const Notifications = (): React.ReactElement => {
  const notifications = useSelector((state: RootState) => state.notification.notifications)

  return <>
    {notifications.map((notification: Notification, index) => (
      <Toast.Root className={`ToastRoot ${notification.type === 'error' ? 'notification-error' : 'notification-success'}`} key={index}>
        <Toast.Description className="ToastDescription">
          {notification.type === 'error' ? (
            <ErrorSvg />
          ) : (
            <SuccessSvg />
          )}
          <span>{notification.title}</span>
        </Toast.Description>
      </Toast.Root>
    ))}
  </>
}
